import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ListColumn } from "src/app/models/list-columns.model";
import { AfterViewInit } from "@angular/core";
import { ListAction } from "src/app/models/list-actions.model";
export interface TableAction {
  label: string;
  icon?: string;
  color?: string;
  className?: string;
  action: () => void;
  visible?: () => boolean;
  disabled?: () => boolean;
}

@Component({
  selector: "app-card-table",
  templateUrl: "./card-table.component.html",
})
export class CardTableComponent implements OnInit, AfterViewInit {
  defaultButtonClass =
  'text-xs font-bold uppercase px-3 py-2 rounded shadow hover:shadow-md bg-blue-500 text-white disabled:opacity-50';

  @Input() public showTitle: boolean = true;
  @Input() public title: string = "Registros";
  @Input() public keyactivos: string = "";
  @Input() public templateClassRow: (row) => string;

  @Output() onactions = new EventEmitter<{ action: string; row: any }>();
  @Input() public columns: ListColumn[] = [];
  @Input() public actions: ListAction<any>[] = [];
  @ViewChild(MatPaginator, { static: true }) public paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) public sort: MatSort;
  public dataSource: MatTableDataSource<any> | null;
  public pageSize: number = 10;

  @Input()
  get color(): string {
    return this._color;
  }
  set color(color: string) {
    this._color = color !== "light" && color !== "dark" ? "light" : color;
  }
  private _color = "light";

  @Input()
  get actionsType(): "menu" | "icons" {
    return this._actionsType;
  }
  set actionsType(color: "menu" | "icons") {
    this._actionsType = color;
  }
  private _actionsType: "menu" | "icons" = "menu";


  @Input() tableActions: TableAction[] = [];

  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }

  ngOnInit(): void {
    if (this.templateClassRow == undefined) {
      this.templateClassRow = (row) => {
        return this.keyactivos != "" && !row[this.keyactivos]
          ? "bg-red-200"
          : "";
      };
    }
    this.dataSource = new MatTableDataSource();
    this.dataSource.data = [];
  }

  public ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  public onFilterChange(value: string) {
    if (!this.dataSource) return;
    this.dataSource.filter = value.trim().toLowerCase();
  }

  setData(rows: any[]) {
    this.dataSource.data = rows;
  }

  update(row: any) {
    this.onactions.emit({ action: "update", row: row });
  }
  delete(row: any) {
    this.onactions.emit({ action: "delete", row: row });
  }
  activate(row: any) {
    this.onactions.emit({ action: "activate", row: row });
  }

  sendAction(actionItem: ListAction<any>, row: any) {
    this.onactions.emit({ action: actionItem.action, row: row });
  }
}
